import isFeatureEnabled from '../../utils/is-feature-enabled';

const appleBusinessChatIsEnabled = !isFeatureEnabled('disableAppleBusinessChat');

// @ts-expect-error - Automatic, Please fix when editing this file
const selectIsAbcSupportedAndAvailable = (state) =>
  (state?.livechat?.isAbcSupported ?? false) && appleBusinessChatIsEnabled;

export default selectIsAbcSupportedAndAvailable;
